import { render, staticRenderFns } from "./c-address.vue?vue&type=template&id=12be801a&scoped=true&"
import script from "./c-address.vue?vue&type=script&lang=js&"
export * from "./c-address.vue?vue&type=script&lang=js&"
import style0 from "./c-address.vue?vue&type=style&index=0&id=12be801a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12be801a",
  null
  
)

export default component.exports